// extracted by mini-css-extract-plugin
export default {"copyButtonEnter":"IB26GJ3wWIcdFdJN99B6","copyButtonEnterActive":"Mscbz1jBq9DindCEFcJE","copyButtonExit":"fwoBhLi7KNYT4qfj5Gjy","copyButtonExitActive":"mw00nsW1bYZazb7F47Ne"};